const RTL_LANGUAGES = ["fa", "ar"];

export default RTL_LANGUAGES